import { ADVISORY } from "./advisory";
import { EXPERTISE } from "./expertise";
import { PU_ARTICLES, SIL_ARTICLES, CALCULATORS } from "./technical";
import { INSIGHTS } from "./insights";
import { RESOURCES } from "./resources";
import { REPORTS } from "./reports";

// Flat searchable index across all site content.
export const SEARCH_INDEX = [
  ...ADVISORY.map((a) => ({ type: "Advisory", title: a.title, text: `${a.short} ${a.lead}`, to: `/advisory/${a.slug}` })),
  ...EXPERTISE.map((e) => ({ type: "Expertise", title: e.title, text: `${e.short} ${e.lead}`, to: `/expertise/${e.slug}` })),
  ...PU_ARTICLES.map((a) => ({ type: "Polyurethane", title: a.title, text: a.summary, to: `/technical-hub/polyurethane/${a.slug}` })),
  ...SIL_ARTICLES.map((a) => ({ type: "Silicones", title: a.title, text: a.summary, to: `/technical-hub/silicones/${a.slug}` })),
  ...CALCULATORS.map((c) => ({ type: "Calculator", title: c.title, text: `${c.short} ${c.formula}`, to: `/technical-hub/calculators/${c.slug}` })),
  ...INSIGHTS.map((a) => ({ type: "Insight", title: a.title, text: `${a.excerpt} ${a.category}`, to: `/insights/${a.slug}` })),
  ...RESOURCES.map((r) => ({ type: "Resource", title: r.name, text: `${r.tagline} ${r.category} ${r.whatItDoes}`, to: `/resources/${r.slug}` })),
  ...REPORTS.map((r) => ({ type: "Report", title: r.title, text: `${r.excerpt} ${(r.keywords || []).join(" ")}`, to: r.path })),
];

export function searchSite(query) {
  const q = query.trim().toLowerCase();
  if (!q) return [];
  const terms = q.split(/\s+/);
  return SEARCH_INDEX.map((item) => {
    const hay = `${item.title} ${item.text} ${item.type}`.toLowerCase();
    let score = 0;
    for (const t of terms) {
      if (item.title.toLowerCase().includes(t)) score += 3;
      if (hay.includes(t)) score += 1;
    }
    return { item, score };
  })
    .filter((r) => r.score > 0)
    .sort((a, b) => b.score - a.score)
    .map((r) => r.item);
}
